import { register } from '@shopify/theme-sections';
import Swiper from 'swiper';

const selectors = {
  target: '.featured-collection--',
};

register('featured-collection-section', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) {
      return;
    }

    const desktopProductCount = targetSelector.dataset.desktopProductRow;
    const mobileProductCount = targetSelector.dataset.mobileProductRow;
    const gap = parseInt(targetSelector.dataset.gap);

    const swiper = new Swiper(target, {
      slidesPerView: desktopProductCount,
      loop: true,
      freeMode: false,
      spaceBetween: gap,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: mobileProductCount,
        },
        700: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: desktopProductCount,
        },
      },
    });
  },
});
